import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuida from "../pages/article/page";
import ArticleSicurezza from "../pages/article/sicurezza/page";
import ArticleConfronto from "../pages/article/confronto/page";
import ArticleTutorial from "../pages/article/tutorial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo-itaobuy-spreadsheet-guida",
    element: <ArticleGuida />,
  },
  {
    path: "/articolo-sicurezza-itaobuy-spreadsheet",
    element: <ArticleSicurezza />,
  },
  {
    path: "/articolo-confronto-itaobuy-spreadsheet",
    element: <ArticleConfronto />,
  },
  {
    path: "/articolo-tutorial-itaobuy-spreadsheet",
    element: <ArticleTutorial />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;